import React from "react";
import "./App.css";
import {
  AnchorButton,
  Navbar,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
} from "@blueprintjs/core";
import FormPage from "./pages/form/Form.page";

function App() {
  return (
    <div>
      <Navbar>
        <NavbarGroup>
          <AnchorButton minimal icon={"arrow-left"} text={"Back to main site"} href="https://www.portbannatynemarina.co.uk/"/>
          <NavbarDivider />
          <NavbarHeading>Submit a new Work Order form</NavbarHeading>
        </NavbarGroup>
      </Navbar>
      <FormPage />
    </div>
  );
}

export default App;
